import { View } from '@adobe/react-spectrum';
import p from 'prop-types';
import React, { useState } from 'react';

import { WithTimeout } from '@exchange-frontends/components';

import { Label } from './RatingsAndReviews';
import { Review } from './Review';

const MyReviewSection = (props) => {
  const { currentUserReview, setIsUserReviewRendered } = props;

  const [isDeleted, setIsDeleted] = useState(false);
  const [shouldShowDeleteMessage, setShouldShowDeleteMessage] = useState(false);

  return (
    <>
      {!isDeleted && (
        <View borderRadius="regular" borderColor="gray-200" borderWidth="thin" paddingY="24px" paddingX="20px">
          <Review
            belongsToCurrentUser
            review={{
              ...currentUserReview,
              reviewTitle: currentUserReview?.title,
              reviewText: currentUserReview?.text,
            }}
            setDeleteSuccess={() => {
              setIsDeleted(true);
              setShouldShowDeleteMessage(true);
            }}
          />
        </View>
      )}
      <WithTimeout
        shouldShow={shouldShowDeleteMessage}
        setShouldShow={(v) => {
          setIsUserReviewRendered(v);
        }}
      >
        <View borderRadius="regular" borderColor="gray-200" borderWidth="thin" paddingY="24px" paddingX="20px">
          <Label>Your review has been deleted.</Label>
        </View>
      </WithTimeout>
    </>
  );
};

MyReviewSection.propTypes = {
  /** Object containing the current review data */
  currentUserReview: p.object,
};

export default MyReviewSection;
